
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChanges } from "@angular/core";
import { AguasService } from "../../servicios/aguas.service";
import { PersonasService } from "../../servicios/personas.service";
import { Aguas, AuxJasper, ParametroJasper, Contratos, AguaBuscaCuentas, ContratosAltaPruebaInput, CertificadoNoAdeudoInput, AltaContratosInput, AltaContratos, FlujoTramitesInput, ActualizaAltaContratosInput, ActualizaAltaContratos, Privilegios } from "../../entidades/entidades";
import { Observable, empty } from "rxjs";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { RAguasPersonas, json_in, MedioPagos } from "../../entidades/entidades";
import {Personas, ServiciosConsultasInput, Solicitudes, SolicitudDetalles, RegistroBitacoraInput, BuscaTramiteInput, ServiciosConsultas} from "../../entidades/entidades";
import { RAguasPersonasService } from "../../servicios/r-aguas-personas.service";
import { Medidores } from "../../entidades/entidades";

import { MedidoresService } from "../../servicios/medidores.service";
import { BuscaContratoService } from "../../servicios/busca-contrato.service";
import { AltaContratosService} from "../../servicios/alta-contratos.service";
import { SolicitudesService } from "../../servicios/solicitudes.service";
import { SolicitudDetallesService } from "../../servicios/solicitud-detalles.service";
import { RegistraPagosService } from "../../servicios/registra-pagos.service";
import { CatTipoContratoPersonasService } from '../../servicios/cat-tipo-contrato-personas.service';
import { CatTipoContratoPersonas } from "../../entidades/entidades";

import { AguasComponent } from '../../componentes/aguas/aguas.component';
import { PersonasComponent } from '../../componentes/personas/personas.component';
import { AguaBuscaCuentasComponent } from '../../componentes/agua-busca-cuentas/agua-busca-cuentas.component';

import { Router, ActivatedRoute } from "@angular/router";

declare var $: any;

import { JasperService } from "../../servicios/jasper.service";
import { AuthenticationService } from "../../../app/servicios";
import { AguaBuscaCuentasService } from "../../../app/servicios/agua-busca-cuentas.service";
import { CertificadoNoAdeudoService } from "../../servicios/certificado-no-adeudo.service";
import { ServiciosConsultasService } from "../../servicios/servicios-consultas.service";
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { FlujoTramitesInputService } from "../../../app/servicios/flujo-tramites.service";
import { PrivilegiosService } from '../../servicios/privilegios.service';


@Component({
  selector: "app-contratos",
  templateUrl: "./contratos.component.html",
  styleUrls: ["./contratos.component.css"],
})
export class ContratosComponent implements OnInit {
  public aguas$: Observable<Aguas>;
  @Output("aguasOutput") aguasOutput: EventEmitter<Aguas>;
  @Output("personas") personas: EventEmitter<Personas>;
  @Output("contratoType") contratoType: EventEmitter<number>;
  @Input("buscaTramite") buscaTramite: BuscaTramiteInput;
  public aguasLimpio: Aguas;
  public aguasProceso: Aguas;
  public rAguasPersonas: RAguasPersonas;
  public personas$: Observable<Personas>;
  public personasLimpio: Personas;
  public personaRecibida: Personas ;
  public personasPadron: RAguasPersonas;

  public muestraMensaje = new MuestraMensaje();
  public contratos = new Contratos();
  public altaContratosInput: AltaContratosInput;
  public modificaDatos: AltaContratosInput;
  public actualizaAltaContratosInput: ActualizaAltaContratosInput;
  public actualizaAltaContratos : ActualizaAltaContratos; 
  public aguasReturn: Aguas;
  public aguaPadron: number;
  public auxJasper: AuxJasper;
  public usuario: any;
  public altaDerivada: boolean = false;
  public medioPagos: MedioPagos;

  public IdSolicitud: number;
  public IdSolicitudDetalle: number;
  public IdAgua: number;
  public IdPropietario: number;
  public IdConcepto: number;
  public tramiteListo: boolean = false;
  public imprimeFormato: boolean = false;
  public soloFormato: boolean = false;
  public Ag: number;
  public NuevaSolicitud: number;
  public tipoContrato1:   number;
  public contratoSelect: number;
  public esAltaContrato = false;
  public padron: boolean = false;
  public esTramite: boolean = false;
  

  //SE AGREGA VARIABLE PARA IDENTIFICAR SI EL PREDIO ES SI TOMA
  public prediosintoma:boolean=false;
  public idAguaPredioSinToma: number;

  public datosSolicitud = new Solicitudes();
  public datosDetalles = new Array<SolicitudDetalles>();
  public buscaAgua = new AguaBuscaCuentas();
  public fti: FlujoTramitesInput;
  public json_in: json_in;
  public _id_persona: number;
  public display: boolean = false;
  public datos: any;
  public idAgua: any;
  public soloLecturaAguas: boolean = false;
  public soloLecturaPersonas: boolean = false;

  public isLoading: boolean = true;
  public observacion: string;
  
  public tableWidget: any;
  public registroBitacora = new RegistroBitacoraInput();

  @ViewChild(AguasComponent, { static: false }) childAguasComponent;
  @ViewChild(PersonasComponent, { static: false }) childPersonasComponent;
  @ViewChild(AguaBuscaCuentasComponent, { static: false }) childAguasBuscaComponent;  
  
  public progressBar: boolean = false;

  constructor(
    private aguasService: AguasService,
    private rAguasPersonasService: RAguasPersonasService,
    private personasService: PersonasService,
    private contratosService: BuscaContratoService,
    public _jasperService: JasperService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private solicitudesService: SolicitudesService,
    private RegistraPagosService: RegistraPagosService,
    private solicitudDetallesService: SolicitudDetallesService,
    private serviciosConsultasService: ServiciosConsultasService,
    private aguaBuscaCuentasService: AguaBuscaCuentasService,
    private authenticationService:AuthenticationService,
    private certificadoNoAdeudoService: CertificadoNoAdeudoService,
    private catTipoContratoPersonasService: CatTipoContratoPersonasService,
    private registroBitacoraService: RegistroBitacoraService,
    private altaContratosService: AltaContratosService,
    private flujoTramitesInputService : FlujoTramitesInputService,
    private privilegiosService: PrivilegiosService,
  ){
    this.aguasOutput = new EventEmitter();
    this.contratoType = new EventEmitter();


  }
  async ngOnInit() {
    try{
        this.progressBar = true;

        this.isLoading = true; // Inicia la carga

        await this.authenticationService.getUserByToken();
        this.usuario = this.authenticationService.currentUserValue;
        //Bandera que se emplea a traves de la ruta para habilitar o deshabilitar elementos de html
        const rutaActual = this.router.url;
        if(rutaActual === '/atencion/padron'){
          this.padron = true;
        }else if(rutaActual === '/comercializacion/contratos'){
          this.padron = false;
        }else{
          this.padron = false; 
        }  
          this.datos = history.state.example;

          if(this.datos)
          {
            if(this.datos.estadoTramite === 'CONTRATACIÓN (FIRMA)' && this.datos.estatus === 'TERMINADO'){
              this.soloFormato = true;
              this.imprimeFormato = true;
            }
            this.IdSolicitudDetalle = this.datos.idSolicitudDetalle;
            this.IdSolicitud = this.datos.idSolicitud;
            await this.confirmaSolicitud(this.datos);
          }else if(!this.padron){
            this.router.navigateByUrl("atencion/informacion");
            this.muestraMensaje.notification(
              "No existe una solicitud Previa",
              "top",
              "center"
            );
          }else if(this.padron){
            //Busca si tiene permiso de editar
            const tienePermiso = await this.getPrivilegios();
            if (tienePermiso) {
              this.soloLecturaAguas = false;
              this.soloLecturaPersonas = false;
            } else{
              this.soloLecturaAguas = true;
              this.soloLecturaPersonas = true;
            }
          }
      } catch {
        this.muestraMensaje.notification(
          "No existe una solicitud Previa",
          "top",
          "center"
        );
      }finally{
        this.progressBar = false;
        this.isLoading = false; // Finaliza la carga
      }
  }

  showDialog() {
    this.display = true;
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    // Este mét odo se activa cada vez que la entrada 'myInput' cambia.

  }

  async getPrivilegios() {
      try {
        let objUrl = new Privilegios();
        objUrl.uuid = 'fb19a66c-7aa0-4b88-a508-dba784d0bc98';
        let conPrivilegio = await this.privilegiosService.GetPrivilegioByUUID(objUrl).toPromise();
        return conPrivilegio;
      } catch (e) {
        if (e.response) throw { message: e.response.data };
        else throw e;
      } finally {
        console.log("Paso por getPrivilegios");
      }
  }

  //Se utiliza para realizar las busquedas de las cuentas 
  // cuando se crea un nuevo contrato
  async getAguas(id: number) {
    try {
      //await this.limpia();
      const datoRetorno = await this.aguasService.getSingle(id).toPromise();
      let aguaR = new Aguas();
      //this.altaDerivada =  true;
      if (datoRetorno.id != 0) 
      {
        aguaR = datoRetorno;
        //aguaR.idTipoToma = 1;
        //aguaR.idTipoUso = this.tipoContrato;

        // busca datos persona 
        let rAguasPersonas = new RAguasPersonas();
        rAguasPersonas.idAgua = aguaR.id;
        await this.getRAguasPersonas(rAguasPersonas);
        if (this.rAguasPersonas.idPersona)
          this.getPersonas(this.rAguasPersonas.idPersona);

        // se actualiza entidad para derivada 
       // aguaR.id = null;
       
        
        aguaR.idUsuarioGuardo = this.usuario.id;
        await this.aguasOutput.emit(aguaR);

        this.childAguasComponent.aguasForm = aguaR;
      }

    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getAguas");
    }
  }
  async getPersonas(id: number) {
    try {

      const datoRetorno = await this.personasService.getSingle(id).toPromise();
      this.personaRecibida = datoRetorno;
      this.personas$ = await this.personasService.getSingle(id);

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPersonas");
    }
  }
  async test(event: number){
    try{
      this.contratoSelect = event;
    }catch (e){
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por contrato")
    }
  }

  async confirmaSolicitud(datos){
  try{
      this.progressBar = true;

      var serviciosConsultasInput = new ServiciosConsultasInput();
      serviciosConsultasInput.idSolicitud = this.IdSolicitud;
      const datoRetorno = await this.serviciosConsultasService.getBusquedas(serviciosConsultasInput).toPromise();
      if(datoRetorno.find(x => x.esApertura == true) ) 
      {
        this.esAltaContrato = true;
      }
this      
      if(datoRetorno.find(x => x.noEditable == true)){
        this.soloLecturaAguas = true;
        this.soloLecturaPersonas = true;
      }
      if (datoRetorno.find(x => x.noEditable === false && [1112, 1113, 1114].includes(x.idConcepto))) {
        this.soloLecturaPersonas = false;
        this.soloLecturaAguas = true;
      }
      if(this.datos.estadoTramite === 'CONTRATACIÓN (FIRMA)' && this.datos.estatus === 'EN PROCESO'){
        this.esAltaContrato = true;
        this.tramiteListo = true;
        this.imprimeFormato = true;
      }
      if(datoRetorno.some(x => x.idConcepto != null)){
        this.esTramite = true;
      } 
      if(datos.idAgua) await this.getAguas(datos.idAgua);
    }catch{

    }finally
    {
      this.progressBar = false;
      console.log("Paso por confirmaSolicitud");
    }
    
  }
  
  //Se utiliza para buscar o consultar las cuentas desde padron
  async AguasBusca(aguas: number){
    try{
      this.progressBar = true;
      this.Ag = aguas;
      if(aguas == null){
         return
      }
      const datoRetorno = await this.aguasService.getSingle(aguas).toPromise();

      await this.aguasOutput.emit(datoRetorno);
      let personasPadron = new RAguasPersonas;
      personasPadron.idAgua = aguas;
      await this.getRAguasPersonas(personasPadron);
      if (this.rAguasPersonas.idPersona)
        this.getPersonas(this.rAguasPersonas.idPersona);
    }catch (e){
      this.muestraMensaje.error(e.message, "top", "center");
    }finally{
      this.progressBar = false;
      console.log("Paso por childAguasBusca")
    }
   
  }
  
  async childAguas(aguas: Aguas) {
    try {
      this.aguasProceso = aguas;
      this.IdConcepto = aguas.idTipoUso;

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por childAguas");
    }
  }
  async getRAguasPersonas(rAguasPersonas: RAguasPersonas) {
    try {
      const datoRetorno = await this.rAguasPersonasService.getBusquedas(rAguasPersonas).toPromise();
        if(datoRetorno[0])
        {
          this.rAguasPersonas = datoRetorno[0];
        }else{
          this.rAguasPersonas = new RAguasPersonas();
        }      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getRAguasPersonas");
    }
  }

  //Guarda los datos de un nuevo contrato
  async guardaContrato()  
  {
    try
    {
      this.progressBar = true;
      debugger;
      if(!this.childPersonasComponent.personasForm.valid) 
        {
          throw new Error("Por favor, valide todos los campos con alerta antes de guardar.")     
        }

      if(this.childPersonasComponent.personasForm.value.nombre == null && this.childPersonasComponent.personasForm.value.primerApellido == null
      && this.childPersonasComponent.personasForm.value.segundoApellido == null 
      && this.childPersonasComponent.personasForm.value.razonSocial == null)
      {
        //await this.muestraMensaje.error("La información del contribuyente no puede ir vacía.","top","center");
        //return;
        throw new Error("La información del contribuyente no puede ir vacía.")
      }

      if(!this.personaRecibida){this.personaRecibida = new Personas();}
      if(this.personaRecibida.rfc == null) {this.personaRecibida.rfc = 'XAXX010101000';}
      if(this.childAguasComponent.aguasForm.value.idTipoServicio == 2)
      {
        this.prediosintoma = true;
      }else{
        this.prediosintoma = false;
      }
    
      if(!this.childAguasComponent.aguasForm.value.idTipoToma || !this.childAguasComponent.aguasForm.value.idTipoServicio)
      {
        throw new Error("Ninguno de estos campos puede ir vacío: Tipo Servicio y Tipo Toma."); 
      }
      if(this.childAguasComponent.aguasForm.value.idAguaZona == null && this.childAguasComponent.aguasForm.value.idColonia == null)
      {
        throw new Error("Debes seleccionar una colonia.")
      }
      if(this.childAguasComponent.aguasForm.value.idTipoContrato == null){
          throw new Error("Debes seleccionar un tipo de contrato.")
      }

      if(this.childAguasComponent.contratos.length == 0){
        throw new Error("Debes agregar al menos un contrato.")
      }

      if (this.childAguasComponent.aguasForm.value.idTipoContrato == 1) {
        const contratos = this.childAguasComponent.contratos;
      
        if (
          contratos.length !== 2 ||
          !contratos.some(c => c.idTipoContrato === 2) ||
          !contratos.some(c => c.idTipoContrato === 3)
        ) {
          throw new Error(
            "Para un contrato de Agua y Drenaje, debes agregar exactamente un contrato de Agua y un contrato de Drenaje."
          );
        }
      } else if (this.childAguasComponent.aguasForm.value.idTipoContrato === 2) {
        // Para contrato solo de Agua, debe haber solo un contrato y ser de tipo 2
        if (
          this.childAguasComponent.contratos.length !== 1 ||
          this.childAguasComponent.contratos[0].idTipoContrato !== 2
        ) {
          throw new Error(
            "Para un contrato solo de Agua, debes agregar únicamente un contrato de tipo Agua."
          );
        }
      } else if (this.childAguasComponent.aguasForm.value.idTipoContrato === 3) {
        // Para contrato solo de Drenaje, debe haber solo un contrato y ser de tipo 3
        if (
          this.childAguasComponent.contratos.length !== 1 ||
          this.childAguasComponent.contratos[0].idTipoContrato !== 3
        ) {
          throw new Error(
            "Para un contrato solo de Drenaje, debes agregar únicamente un contrato de tipo Drenaje."
          );
        }
      }
      


      this.childAguasComponent.aguasForm.value.selectedDelegacion = null;
      this.childAguasComponent.aguasForm.value.selectedColonia = null;
      this.childAguasComponent.aguasForm.value.selectedCalle = null;
      this.childAguasComponent.aguasForm.value.selectedCalle1 = null;
      this.childAguasComponent.aguasForm.value.selectedCalle2 = null;
      this.childAguasComponent.aguasForm.value.selectedAguaZona = null;
      this.childAguasComponent.aguasForm.value.selectedGiro = null;

      
      this.childAguasComponent.aguasForm.value.dato = JSON.stringify({
        agua: this.childAguasComponent.tieneAgua,
        dre: this.childAguasComponent.tieneDrenaje,
        sane: this.childAguasComponent.tieneSaneamiento,
        infra: this.childAguasComponent.tieneInfraestructura,
        estado: "PENDIENTE CONTRATAR"
      });

      this.childAguasComponent.aguasForm.value.idSolicitud = this.IdSolicitud;
      this.childAguasComponent.aguasForm.value.idUsuarioGuardo = this.usuario.id;

      var aguasJson = JSON.stringify({
        agua: this.childAguasComponent.aguasForm.value,
        persona: this.childPersonasComponent.personasForm.value,
        contratos: this.childAguasComponent.contratos,
      });

      this.altaContratosInput = new AltaContratosInput();
      this.altaContratosInput.altaContratos = aguasJson; 
      
      const datoRetorno = await this.altaContratosService.postOperaciones(this.altaContratosInput).toPromise();
      this.aguasReturn = new Aguas();
      if(datoRetorno[0]){
        this.aguasReturn = datoRetorno[0];
        this.contratos.idAgua =  this.aguasReturn.id;

        this.tramiteListo = true;

        //await this.addContrato(this.contratos);
        this.aguasOutput.emit(this.aguasReturn);
      }else{
        this.aguasReturn = new Aguas();
      }    
     

    }catch(ex){
      this.muestraMensaje.error(ex.message, "top", "center");
      this.progressBar = false;
    }
    finally{
      this.progressBar = false;
    }
  }
  
  //Actualiza los datos del padron
  async guardaPadron(){
    try
    {
      this.progressBar = true;
      if(!this.personaRecibida)
      {
        this.personaRecibida = new Personas();
      }
  
      if(this.personaRecibida.rfc == null) 
      {
        this.personaRecibida.rfc = 'XAXX010101000';
      }
      if(this.childAguasComponent.aguasForm.value.idTipoServicio == 2)
      {
        this.prediosintoma = true;
      }else{
        this.prediosintoma = false;
      }
      if(!this.childAguasComponent.aguasForm.value.idTipoToma || !this.childAguasComponent.aguasForm.value.idTipoServicio)
      {
        throw new Error("Ninguno de estos campos puede ir vacío: Tipo Servicio y Tipo Toma."); 
      }

      //Si no existe colonia o idAguaZona ya no hace inserción de NADA
      if(this.childAguasComponent.aguasForm.value.idAguaZona == null && this.childAguasComponent.aguasForm.value.idColonia == null)
      {
        throw new Error("Debes seleccionar una colonia.")
      }

      if(this.childAguasComponent.aguasForm.value.idTipoContrato == null){
          throw new Error("Debes seleccionar un tipo de contrato.")
      }

      if(this.childPersonasComponent.personasForm.value.nombre == null && this.childPersonasComponent.personasForm.value.primerApellido == null
        && this.childPersonasComponent.personasForm.value.segundoApellido == null 
        && this.childPersonasComponent.personasForm.value.razonSocial == null)
        {
          throw new Error("La información del contribuyente no puede ir vacía.")
        }
      
      this.childAguasComponent.aguasForm.value.selectedDelegacion = null;
      this.childAguasComponent.aguasForm.value.selectedColonia = null;
      this.childAguasComponent.aguasForm.value.selectedCalle = null;
      this.childAguasComponent.aguasForm.value.selectedCalle1 = null;
      this.childAguasComponent.aguasForm.value.selectedCalle2 = null;
      this.childAguasComponent.aguasForm.value.selectedAguaZona = null;
      this.childAguasComponent.aguasForm.value.selectedGiro = null;

      this.childAguasComponent.aguasForm.value.dato = JSON.stringify({
        agua: this.childAguasComponent.tieneAgua,
        dre: this.childAguasComponent.tieneDrenaje,
        sane: this.childAguasComponent.tieneSaneamiento,
        infra: this.childAguasComponent.tieneInfraestructura
      }); 

      this.childAguasComponent.aguasForm.value.idSolicitud = this.IdSolicitud;
      this.childAguasComponent.aguasForm.value.idUsuarioGuardo = this.usuario.id;

      
      var aguasJson = JSON.stringify({
        agua: this.childAguasComponent.aguasForm.value,
        persona: this.childPersonasComponent.personasForm.value,
        contratos: this.childAguasComponent.contratos,
      });


      this.modificaDatos = new AltaContratosInput();
      this.modificaDatos.altaContratos = aguasJson; 
     
      const valorRetorno = await this.altaContratosService.postModificacion(this.modificaDatos).toPromise();
      let aguasRetorna = new Aguas();
      
      if(valorRetorno[0]){
        aguasRetorna = valorRetorno[0];
        this.aguasOutput.emit(aguasRetorna);
      }else{
        aguasRetorna = new Aguas();
      }

      this.muestraMensaje.notification("Se guardaron correctamente los datos de padron", "top", "center");
      
      await this.TerminarCaptura(false)
      
    }catch (e)
    {
      this.muestraMensaje.error(e.message, "top", "center");
      this.progressBar = false;
    }finally{
      console.log("Paso por modifica Padron")
      this.progressBar = false;
    }
  }
  
  // async limpia(){

  // //Limpiar los campos de los formularios
  // this.childAguasComponent.aguasForm.reset();
  // this.childPersonasComponent.personasForm.reset();
  // }


  async addContrato(contrato: Contratos) {
    this.contratos = contrato;
    this.contratos.idUsuario = this.usuario.id;

    let altaContrato = new ContratosAltaPruebaInput;

    altaContrato.idAgua      = contrato.idAgua;
    altaContrato.idSolicitud = this.IdSolicitud.toString();
    altaContrato.idUsuario   = this.usuario.id;
    altaContrato.aniosCalculados = this.childAguasComponent.anioGenerado;
    
    if (this.prediosintoma == true) 
    {
      if(this.childAguasComponent.tieneInfraestructura == true)
      {
        altaContrato.aniosCalculados = this.childAguasComponent.anioGenerado;
      }else{
        altaContrato.aniosCalculados = 0;
      }
    }else{
      altaContrato.aniosCalculados = 5;
    }

    this.contratos.idSolicitud = this.IdSolicitud.toString();
    this.IdAgua = contrato.idAgua;

    
    try {
      const datoretorno = await this.contratosService.getBusquedas(altaContrato).toPromise();
      this.muestraMensaje.notification("Proceso Concluido", "top", "center");
      this.contratos = datoretorno;
      if(datoretorno)
      {
        this.tramiteListo = true;
      }
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addContrato");
    }
  }
  
  async TerminarCaptura(regresa: boolean){ 
    try{
      this.progressBar = true;

      this.fti  = new FlujoTramitesInput();
      this.fti.idSolicitudDetalle = this.IdSolicitudDetalle;
      this.fti.inicio = false;
      this.fti.idUsuario = this.usuario.id;
      this.fti.idEstatus = null;
      this.fti.idEtapaTramite = null;
      this.fti.observaciones = this.observacion;
      this.fti.regresaFlujo = regresa;

      const datoRetorno = await this.flujoTramitesInputService.getBusquedas(this.fti).toPromise();

      if (!this.padron || this.esTramite) {
        this.router.navigateByUrl("atencion/informacion");
      }
      else{
        this.childAguasComponent.previousAguaId = undefined;
        await this.childAguasBuscaComponent.buscaCuentaAgua()
      }
  
      this.muestraMensaje.notification("Guardar con éxito","top","center");

    }catch(e){
      this.muestraMensaje.error(e.message, "top", "center");
    }finally{
      console.log("Paso por Guardar")
      this.progressBar = false;
    }
  }
  async ActualizaContratos(){
    try{
      this.progressBar = true;
      //actualiza estatus de id_agua y se relaciona con la solicitud
      this.actualizaAltaContratosInput = new ActualizaAltaContratosInput();  
     
        this.actualizaAltaContratosInput.idSolicitud = this.IdSolicitud;
      
        const datoRetorno = await this.altaContratosService.postActualizaAltaContratos(this.actualizaAltaContratosInput).toPromise();
        this.actualizaAltaContratos = new ActualizaAltaContratos();
        this.actualizaAltaContratos = datoRetorno[0];
        await this.imprimeSolicitud(this.actualizaAltaContratos);
      
    }catch(e){
      this.muestraMensaje.error(e.message, "top", "center");
    }finally{
      console.log("Paso por ActualizaContratos")
      this.progressBar = false;
    }
  }    
  
  async imprimeSolicitud(AAC: ActualizaAltaContratos) {
    try{
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "";
      switch (AAC.idTipoContrato) {
        case 1:
          this.auxJasper.JasperReport.nombreReporte = "ContratoAguaDrenaje";
          break;
        case 2:
          this.auxJasper.JasperReport.nombreReporte = "ContratoAguaPotable";
          break;
        case 3:
          this.auxJasper.JasperReport.nombreReporte = "ContratoDrenajeSanitario";
          break;
        case 4:
          this.auxJasper.JasperReport.nombreReporte = "ContratoEntreRios";
          break;
        case 5:
          this.auxJasper.JasperReport.nombreReporte = "ContratoBocaNegra";
          break;
        case 6:
          this.auxJasper.JasperReport.nombreReporte = "ContratoTomaenCondominio";
          break;
        case 7:
          this.auxJasper.JasperReport.nombreReporte = "ContratoProvicionalAguaPotable";
          break;
        default:
            // Handle unexpected contratoSelect value
            this.muestraMensaje.error("No existe registro del Contrato", "top", "center");
          break;
      }
      this.auxJasper.JasperReport.tipo = "pdf";
      const parametroJasper = new ParametroJasper();
      parametroJasper.nombre = "_id_agua";
      parametroJasper.valor = AAC.idAgua.toString();
      this.tramiteListo = true;
      await this.auxJasper.ParametroJasper.push(parametroJasper);
      await this.showDialog();


    }catch(e){
      this.muestraMensaje.error(e.message, "top", "center");
    }finally{
      console.log("Paso por imprimeSolicitud")
      this.progressBar = false;
    }
  }  
}
